<template>
  <div v-if="tabs.length" class="page-content">
    <div class="tab-wrapper">
      <van-tabs
        v-model="activeTab"
        line-width="20px"
        color="#15bb5c"
        title-active-color="#15bb5c"
        title-inactive-color="#262626"
        sticky
        @change="onTabChange"
      >
        <van-tab
          v-for="tab in tabs"
          :key="tab.type"
          :title="tab.name"
          :name="tab.type"
        />
      </van-tabs>
    </div>
    <div class="rule-content">
      <div
        v-for="(moduleInfo, index) in rules"
        :key="index"
        class="rule-module"
      >
        <div class="title">{{ moduleInfo.title }}</div>
        <div
          v-for="(ruleInfo, ruleIndex) in moduleInfo.children"
          :key="ruleIndex"
          class="rule-item"
        >
          <div class="rule-title" v-html="ruleInfo.desc"></div>
          <div
            v-for="(subInfo, subIndex) in ruleInfo.children"
            :key="subIndex"
            class="sub-rule-item"
          >
            <div class="sub-rule-desc" v-html="subInfo"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import { API } from '@/api'
import Url from '@mc/mc-utils/js/url/url'
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '服务费规则'
      })
      vm.getOrderFeetabs()
    })
  },
  data() {
    return {
      rules: [],
      activeTab: 1,
      tabs: []
    }
  },
  methods: {
    onTabChange(name) {
      // eslint-disable-next-line eqeqeq
      this.getServiceFee(name)
    },
    async getOrderFeetabs() {
      this.$Loading()
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      let type = query.type || hashQuery.type
      try {
        const data = await API.shippingFee.getOrderFeetabs()
        this.tabs = data?.fee_tab || []
        if (this.tabs.length && !type) {
          type = this.tabs[0].type
        }
        this.getServiceFee(type)
      } catch (error) {
        this.$catch(error)
      }
      this.$Loading.hide()
    },
    async getServiceFee(type) {
      try {
        const data = await API.shippingFee.getOrderFeeRules({
          type
        })
        if (data.fee_rule.length) {
          this.rules = data.fee_rule || []
        }
      } catch (error) {
        this.$catch(error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.page-content {
  padding: 0 20px;

  background-color: #fff;
  .tab-wrapper {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 3;
  }
  .rule-content {
    @include flex-column;
  }
  .rule-module {
    margin-top: 0.4rem;

    font-size: 0.28rem;
    color: #262626;
    &:last-child {
      padding-bottom: 10px;
    }

    .title {
      margin-bottom: 0.24rem;

      font-size: 0.32rem;
      font-weight: bold;
    }
    .rule-title,
    .sub-rule-desc {
      margin-bottom: 0.24rem;
    }
  }
}
</style>
